import styled from 'styled-components';
// import { Link } from 'react-router-dom';

export const ServicesSectionContainer = styled.section`
  width: 100%;
  padding: var(--space-xxxxl) var(--space-xxxl);
  background: linear-gradient(180deg, var(--offWhite) 0%, var(--white) 100%);
  @media screen and (max-width: 950px) {
    padding: var(--space-xxxl) var(--space-xl);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) var(--space-m);
  }
`;

export const ServicesIntro = styled.div`
  max-width: 780px;

  margin: 0 auto var(--space-xxxl) auto;

  text-align: center;
`;

export const ServicesHeader = styled.h2`
  margin: var(--space-xs) 0 var(--space-m) 0;

  color: var(--grey7);

  font-size: clamp(2.1rem, 4vw, 3.5rem);
  line-height: 1;
  font-weight: 900;

  letter-spacing: -0.04em;
`;

export const ServicesDescription = styled.p`
  max-width: 680px;

  margin: 0 auto;

  color: var(--grey4);

  font-size: 1rem;
  line-height: 1.8;
  font-weight: 500;
`;

export const ServicesContainer = styled.div`
  width: min(100%, 1380px);

  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(5, 1fr);

  @media screen and (max-width: 1050px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ServiceLink = styled.a`
  width: 100%;

  color: inherit;
  text-decoration: none;
`;

export const ServiceIcon = styled.div`
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--borderRadiusButton);
  background: linear-gradient(135deg, var(--yellow1) 0%, var(--orange7) 100%);
  color: var(--orange5);
  font-size: 1.35rem;
  box-shadow: inset 0 0 0 1px rgba(230, 139, 7, 0.12);
  margin-bottom: var(--space-m);
`;

export const ServiceContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-s);

  flex: 1;

  h4 {
    margin: 0;

    color: var(--grey7);

    font-size: 1.15rem;
    line-height: 1.3;
    font-weight: 850;

    letter-spacing: -0.02em;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.95rem;
    line-height: 1.75;
    font-weight: 500;
  }
`;

export const ServiceEyebrow = styled.span`
  color: var(--orange5);

  font-size: 0.75rem;
  font-weight: 900;

  text-transform: uppercase;
  letter-spacing: 0.12em;
`;
export const ServiceAction = styled.span`
  margin-top: auto;

  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  color: var(--grey6);

  font-size: 0.9rem;
  font-weight: 850;

  transition: color 0.2s ease;

  span {
    display: inline-block;

    transition: transform 0.2s ease;
  }
`;
export const EachService = styled.article`
  min-height: 280px;

  padding: var(--space-xxl) var(--space-xl);

  display: flex;
  flex-direction: column;

  position: relative;

  transition:
    transform 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.55);
  }

  &:hover ${ServiceAction} {
    color: var(--orange5);

    span {
      transform: translateX(4px);
    }
  }

  /* Vertical divider */
  &:not(:last-child)::after {
    content: '';

    position: absolute;

    top: 18%;
    right: 0;

    width: 1px;
    height: 64%;

    background: linear-gradient(
      180deg,
      transparent 0%,
      rgba(15, 23, 42, 0.08) 20%,
      rgba(15, 23, 42, 0.08) 80%,
      transparent 100%
    );
  }

  @media screen and (max-width: 1050px) {
    border-bottom: 1px solid rgba(15, 23, 42, 0.06);

    &:nth-child(2)::after {
      display: none;
    }
  }

  @media screen and (max-width: 600px) {
    min-height: auto;

    padding: var(--space-xl) var(--space-m);

    border-bottom: none;

    &:not(:last-child)::after {
      display: none;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    }
  }
`;
